import CountUp from 'countup.js';
import Swiper from 'swiper';
import Cocoen from 'cocoen';
import 'is-in-viewport';

function mobileCheck() {
  if ( '767' < winWidth ) {
    md = true;
  } else {
    md = false;
  }
}

let winWidth = $(window).width(),
    md       = false;

mobileCheck();

export default {
  init() {
    // JavaScript to be fired on the home page

    let animatedElements = '.btn-order-now';
    $(animatedElements).addClass('animated');

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $(window).resize(function() {
      winWidth = $(window).width();
      mobileCheck();
    });

    /**
     * countUp.js
     */
    let options = {
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimal: '.',
    },
    countUpGames = new CountUp('countup-games', 100, 1000000, 0, 3, options);

    /**
     * Swipers
     * https://idangero.us/swiper/api/
     */

    let playSlider = new Swiper('.play-slider .swiper-container', {
      init:       false,
      autoplay:   true,
      effect:     'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el:        '.swiper-pagination',
        clickable: true,
      },
    }),

    playFeaturesSlider = new Swiper('.play-features-slider-container', {
      init:          false,
      autoplay:      true,
      slidesPerView: 1,
    });

    if (!md) {
      playFeaturesSlider.init();
    } else {
      playSlider.forEach(function(el) {
        el.init();
      });
    }

    /**
     * Cocoen (A/B slider)
     * https://koenromers.com/cocoen/
     */

    document.querySelectorAll('.cocoen').forEach(function(el){
      new Cocoen(el);
    });

    /**
     * Waypoints (but using isInViewport.js)
     */

    let $featuresSlider    = $('.play-features-slider'),
        $features          = $('.play-features-slider .features-row .feature'),
        $hotspotsContainer = $('.code-hotspots'),
        $hotspots          = $('.code-hotspots .hotspot');

    $(window).scroll(function() {

      // PLAY

      if ($('#play-intro').is(':in-viewport')) {
        countUpGames.start();
      } else {
        countUpGames.reset();
      }

      if ($('#play-slider-1').is(':in-viewport(-200)')) {
        $('#play-slider-1 .controller').delay(800).addClass('is-active');
      } else {
        // $('#play-slider-1 .controller').removeClass('is-active');
      }

      if ($('#play-slider-2').is(':in-viewport(-200)')) {
        $('#play-slider-2 .camera').delay(800).addClass('is-active');
      } else {
        // $('#play-slider-2 .camera').removeClass('is-active');
      }

      if ($('#play-features').is(':in-viewport')) {
        if (!$featuresSlider.hasClass('playing')) {
          $featuresSlider.addClass('playing');
          $features.first().addClass('is-active');

          if (!$featuresSlider.hasClass('hovering')) {
            gbLoopFeatures();
          }
        }
      } else {
        $featuresSlider.removeClass('playing').removeClass('hovering');
        $features.removeClass('is-active');
      }

       // BEND

      $('#section-bend video').each(function() {
        if ($(this).is(':in-viewport')) {
          $(this)[0].play();
        } else {
          $(this)[0].pause();
        }
      });

      if ($('#bend-filters .controller').is(':in-viewport(-100)')) {
        $('#bend-filters .controller').delay(2000).addClass('is-active');
      } else {
        // $('#bend-filters .controller').delay(2000).removeClass('is-active');
      }

      if ($('#bend-ab-slider').is(':in-viewport(100)')) {
        $('#bend-ab-slider .cocoen').addClass('is-animated');
      } else {
        $('#bend-ab-slider .cocoen').removeClass('is-animated');
      }

      // CODE

      if ($('#code-intro .dizzy-card').is(':in-viewport(-200)')) {
        $('#code-intro .dizzy-card').delay(500).addClass('is-active');
        $('#code-intro .dizzy-magic').delay(1000).addClass('is-active');
      } else {
        $('#code-intro .dizzy-magic').removeClass('is-active');
        $('#code-intro .dizzy-card').delay(500).removeClass('is-active');
      }

      if ($('#code-immersion').is(':in-viewport')) {
        if (!$hotspotsContainer.hasClass('playing')) {
          $hotspotsContainer.addClass('playing');
          $hotspots.first().addClass('is-active');

          if (!$hotspotsContainer.hasClass('hovering')) {
            gbLoopImmersion();
          }
        }
      } else {
        $hotspotsContainer.removeClass('playing').removeClass('hovering');
        $hotspots.removeClass('is-active');
      }

      // BUY

      if ($('#buy-now .btn-order-now').is(':in-viewport')) {
        $('#buy-now .btn-order-now').delay(800).addClass('jackInTheBox');
      } else {
        $('#buy-now .btn-order-now').removeClass('jackInTheBox');
      }

    });

    $features
      .on('mouseenter', function() {
        $featuresSlider.removeClass('playing').addClass('hovering');
        $(this).addClass('is-hovering');
      })
      .on('mouseleave', function() {
        $featuresSlider.addClass('playing').removeClass('hovering');
        $(this).removeClass('is-hovering');
      });

    function gbLoopFeatures() {
      setTimeout(function () {
        let $activeFeature = $('.play-features-slider .feature.is-active');

        $activeFeature.removeClass('is-active');

        if (0 === $activeFeature.next().length) {
          $features.first().addClass('is-active');
        } else {
          $activeFeature.next().addClass('is-active');
        }

        gbLoopFeatures();

      }, 8000);
    }

    $hotspots
      .on('mouseenter', function() {
        $hotspotsContainer.removeClass('playing').addClass('hovering');
        $(this).addClass('is-hovering');
      })
      .on('mouseleave', function() {
        $hotspotsContainer.addClass('playing').removeClass('hovering');
        $(this).removeClass('is-hovering');
      });

    function gbLoopImmersion() {
      setTimeout(function () {
        let $activeHotspot = $('.code-hotspots .hotspot.is-active');

        $activeHotspot.removeClass('is-active');

        if (0 === $activeHotspot.nextUntil('.hotspot').last().next().length) {
          $hotspots.first().addClass('is-active');
        } else {
          $activeHotspot.nextUntil('.hotspot').last().next().addClass('is-active');
        }

        gbLoopImmersion();

      }, 8000);
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js